import { SessionActionTypes } from '../../../enums/ActionEnums';
const sessionActions = {
    createInitAction() {
        return {
            type: SessionActionTypes.INIT,
        };
    },
    createLogoutAction() {
        return {
            type: SessionActionTypes.LOGOUT,
        };
    },
    createSetAction(payload) {
        return {
            type: SessionActionTypes.SET,
            payload,
        };
    },
    createNewsletterSubscribeAction() {
        return {
            type: SessionActionTypes.NEWSLETTER_SUBSCRIBE,
        };
    },
};
export default sessionActions;
